/**
 * Custom Cart Drawer
 *
 * Un cart drawer independiente que funciona con AJAX y es compatible con Seal Subscriptions.
 * Intercepta todos los add to cart y muestra el drawer sin redirect a /cart.
 */
(function() {
  'use strict';
 
  // Configuracion
  var config = {
    selectors: {
      drawer: '#CustomCartDrawer',
      overlay: '#CustomCartOverlay',
      container: '#CustomCartContainer',
      closeBtn: '.js-custom-drawer-close',
      cartIcon: '.js-drawer-open-cart, .cart-link, [href="/cart"]'
    },
    classes: {
      drawerOpen: 'is-open',
      overlayVisible: 'is-visible',
      loading: 'is-loading',
      bodyOpen: 'custom-drawer-open'
    },
    moneyFormat: window.theme && window.theme.settings ? window.theme.settings.moneyFormat : '${{amount}}',
    routes: {
      cart: '/cart.js',
      cartAdd: '/cart/add.js',
      cartChange: '/cart/change.js',
      cartUpdate: '/cart/update.js'
    }
  };
 
  // Umbral de envio gratis en EEUU (en centavos): $35.00
  var FREE_SHIPPING_THRESHOLD = 3500;

  // Estado
  var state = {
    isOpen: false,
    isLoading: false,
    cart: null
  };
 
  // Elementos del DOM
  var elements = {};
 
  /**
   * Inicializacion
   */
  function init() {
    // Obtener elementos del DOM
    elements.drawer = document.querySelector(config.selectors.drawer);
    elements.overlay = document.querySelector(config.selectors.overlay);
    elements.container = document.querySelector(config.selectors.container);
 
    if (!elements.drawer || !elements.container) {
      console.error('[Custom Cart Drawer] Elementos del drawer no encontrados');
      return;
    }
 
    console.log('[Custom Cart Drawer] Inicializando...');
 
    // Registrar event listeners
    bindEvents();
 
    // Cargar el carrito inicial
    fetchCart();
 
    console.log('[Custom Cart Drawer] Inicializado correctamente');
  }
 
  /**
   * Registrar event listeners
   */
  function bindEvents() {
    // Interceptar todos los submits de formularios de add to cart
    document.addEventListener('submit', handleFormSubmit, true);
 
    // Cerrar drawer
    document.querySelectorAll(config.selectors.closeBtn).forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });
 
    // Cerrar con overlay
    if (elements.overlay) {
      elements.overlay.addEventListener('click', closeDrawer);
    }
 
    // Cerrar con ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.isOpen) {
        closeDrawer();
      }
    });
 
    // Abrir drawer al hacer click en icono del carrito
    document.querySelectorAll(config.selectors.cartIcon).forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        // Solo si es un link al carrito, no si es el checkout
        var href = this.getAttribute('href');
        if (href === '/cart' || this.classList.contains('js-drawer-open-cart') || this.classList.contains('cart-link')) {
          e.preventDefault();
          // Evitar que el handler nativo de Motion (.js-drawer-open-cart)
          // tambien se dispare y abra el drawer nativo oculto
          e.stopPropagation();
          e.stopImmediatePropagation();
          openDrawer();
        }
      });
    });
 
    // Event delegation para botones de cantidad y eliminar
    elements.container.addEventListener('click', handleContainerClick);
  }
 
  /**
   * Manejar clicks dentro del contenedor del carrito
   */
  function handleContainerClick(e) {
    var target = e.target;
 
    // Boton de incrementar cantidad
    if (target.classList.contains('js-qty-plus') || target.closest('.js-qty-plus')) {
      var btn = target.classList.contains('js-qty-plus') ? target : target.closest('.js-qty-plus');
      var key = btn.dataset.key;
      var currentQty = parseInt(btn.dataset.qty, 10);
      updateItemQuantity(key, currentQty + 1);
      return;
    }
 
    // Boton de decrementar cantidad
    if (target.classList.contains('js-qty-minus') || target.closest('.js-qty-minus')) {
      var btn = target.classList.contains('js-qty-minus') ? target : target.closest('.js-qty-minus');
      var key = btn.dataset.key;
      var currentQty = parseInt(btn.dataset.qty, 10);
      if (currentQty > 1) {
        updateItemQuantity(key, currentQty - 1);
      } else {
        removeItem(key);
      }
      return;
    }
 
    // Boton de eliminar
    if (target.classList.contains('js-remove-item') || target.closest('.js-remove-item')) {
      var btn = target.classList.contains('js-remove-item') ? target : target.closest('.js-remove-item');
      var key = btn.dataset.key;
      removeItem(key);
      return;
    }
  }
 
  /**
   * Interceptar submit de formularios de add to cart
   */
  function handleFormSubmit(e) {
    var form = e.target;
 
    // NO interceptar formularios dentro del drawer (como el checkout)
    if (form.closest('#CustomCartDrawer')) {
      return;
    }
 
    // Verificar si es un formulario de add to cart
    if (!isAddToCartForm(form)) {
      return;
    }
 
    // Verificar si el boton esta deshabilitado
    var submitBtn = form.querySelector('[type="submit"][name="add"], .add-to-cart, .product-form__submit');
    if (submitBtn && submitBtn.disabled) {
      return;
    }
 
    // Prevenir submit nativo
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
 
    console.log('[Custom Cart Drawer] Formulario interceptado');
 
    // Agregar producto al carrito
    addToCart(form, submitBtn);
  }
 
  /**
   * Verificar si es un formulario de add to cart
   */
  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') {
      return false;
    }
 
    var action = form.getAttribute('action') || '';
    var formId = form.getAttribute('id') || '';
    var hasVariantInput = form.querySelector('[name="id"]');
    var hasAddButton = form.querySelector('[name="add"], .add-to-cart, .product-form__submit');
 
    // Excluir formularios que no sean de add to cart
    if (action.indexOf('/checkout') !== -1) {
      return false;
    }
 
    return action.indexOf('/cart/add') !== -1 ||
           form.classList.contains('product-single__form') ||
           form.classList.contains('product-form') ||
           formId.indexOf('AddToCartForm') !== -1 ||
           formId.indexOf('product-form') !== -1 ||
           (hasVariantInput && hasAddButton);
  }
 
  // Cola de promesas para add-to-cart: si hay una peticion en curso,
  // la siguiente se encadena al terminar en lugar de perderse silenciosamente
  var addToCartQueue = Promise.resolve();

  /**
   * Agregar producto al carrito (encola si hay una peticion en curso)
   */
  function addToCart(form, submitBtn) {
    addToCartQueue = addToCartQueue.then(function() {
      return performAddToCart(form, submitBtn);
    });
  }

  /**
   * Ejecutar el add to cart real
   */
  function performAddToCart(form, submitBtn) {
    setLoading(true);
 
    // Mostrar loading en el boton
    if (submitBtn) {
      submitBtn.classList.add('btn--loading');
      submitBtn.disabled = true;
    }
 
    // Serializar formulario
    var formData = new FormData(form);
 
    // Log para debugging
    console.log('[Custom Cart Drawer] Datos del formulario:');
    for (var pair of formData.entries()) {
      console.log('  ' + pair[0] + ':', pair[1]);
    }
 
    // v2.8 (Sep 25): "Frequently bought together" (assets/mw-fbt.js).
    // Si el bloque esta marcado, MWFbt devuelve items[] (producto + add-on)
    // y se manda como JSON: ambas lineas en UNA sola peticion. Si falla o no
    // aplica, se usa el FormData original de siempre.
    var body = formData;
    var headers = undefined;
    try {
      var fbtItems = window.MWFbt && window.MWFbt.itemsFor ? window.MWFbt.itemsFor(form, formData) : null;
      if (fbtItems) {
        body = JSON.stringify({ items: fbtItems });
        headers = { 'Content-Type': 'application/json' };
      }
    } catch (fbtErr) {
      console.warn('[Custom Cart Drawer] FBT ignorado:', fbtErr);
    }

    // Hacer POST a /cart/add.js
    return fetch(config.routes.cartAdd, {
      method: 'POST',
      headers: headers,
      body: body
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw data;
        });
      }
      return response.json();
    })
    .then(function(item) {
      console.log('[Custom Cart Drawer] Producto agregado:', item);
 
      // Restaurar boton
      if (submitBtn) {
        submitBtn.classList.remove('btn--loading');
        submitBtn.disabled = false;
      }
 
      // Actualizar carrito y abrir drawer (solo si el fetch del carrito funciono)
      var refreshPromise = fetchCart().then(function(cart) {
        if (cart) {
          openDrawer();
        }
      });

      // Disparar eventos para compatibilidad
      dispatchCartEvents(item);

      return refreshPromise;
    })
    .catch(function(error) {
      console.error('[Custom Cart Drawer] Error:', error);
 
      // Restaurar boton
      if (submitBtn) {
        submitBtn.classList.remove('btn--loading');
        submitBtn.disabled = false;
      }
 
      setLoading(false);
 
      // Mostrar error
      showError(form, error);
    });
  }
 
  /**
   * Obtener carrito desde el servidor
   */
  function fetchCart() {
    return fetch(config.routes.cart)
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        state.cart = cart;
        renderCart(cart);
        updateCartBubble(cart);
        setLoading(false);
        return cart;
      })
      .catch(function(error) {
        console.warn('[Custom Cart Drawer] Error al obtener carrito:', error);
        setLoading(false);
        // No renderizar ni abrir el drawer con datos vacios/viejos:
        // devolver null para que los callers verifiquen antes de abrir
        return null;
      });
  }
 
  /**
   * Renderizar el carrito
   */
  function renderCart(cart) {
    if (!cart || cart.item_count === 0) {
      renderEmptyCart();
      return;
    }
 
    var html = '<div class="ccd-scrollable">';
 
    // Renderizar items
    cart.items.forEach(function(item) {
      html += renderCartItem(item);
    });
 
    html += '</div>';
 
    // Footer
    html += '<div class="ccd-footer">';
 
    // Descuentos del carrito
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      cart.cart_level_discount_applications.forEach(function(discount) {
        html += '<div class="ccd-footer__discount">';
        html += discount.title + ' (-' + formatMoney(discount.total_allocated_amount) + ')';
        html += '</div>';
      });
    }
 
    // Subtotal
    html += '<div class="ccd-footer__row">';
    html += '<span class="ccd-footer__label">Subtotal</span>';
    html += '<span class="ccd-footer__value">' + formatMoney(cart.total_price) + '</span>';
    html += '</div>';
 
    // Nota de envio
    html += '<p class="ccd-footer__note">Shipping calculated at checkout</p>';
 
    // Boton de checkout - Link directo a /checkout
    html += '<a href="/checkout" class="ccd-footer__checkout">Checkout</a>';
 
    html += '</div>';
 
    elements.container.innerHTML = html;

    // Actualizar barra de progreso de envio gratis
    updateShippingBar(cart);

    // For WSG wholesale customers, fetch and apply wholesale prices
    applyWholesalePricing(cart);
  }

  /**
   * Actualizar la barra de progreso de envio gratis ($35 USD)
   * Se actualiza en cada renderCart; se oculta con el carrito vacio.
   */
  function updateShippingBar(cart) {
    var bar = document.getElementById('CustomCartShippingBar');
    if (!bar) return;

    if (!cart || cart.item_count === 0) {
      bar.hidden = true;
      return;
    }

    var textEl = bar.querySelector('.ccd-shipping-bar__text');
    var fillEl = bar.querySelector('.ccd-shipping-bar__fill');
    var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    var percent = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);

    if (textEl) {
      if (remaining > 0) {
        textEl.textContent = "You're " + formatMoney(remaining) + " away from FREE U.S. shipping";
      } else {
        textEl.textContent = "🎉 You've unlocked FREE U.S. shipping!";
      }
    }

    if (fillEl) {
      fillEl.style.width = percent + '%';
    }

    bar.hidden = false;
  }
 
  /**
   * Renderizar un item del carrito
   */
  function renderCartItem(item) {
    var imageUrl = item.image ? getSizedImageUrl(item.image, '160x160') : 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
 
    var html = '<div class="ccd-item" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">';
 
    // Imagen
    html += '<div class="ccd-item__image">';
    html += '<a href="' + item.url + '">';
    html += '<img src="' + imageUrl + '" alt="' + escapeHtml(item.product_title) + '">';
    html += '</a>';
    html += '</div>';
 
    // Detalles
    html += '<div class="ccd-item__details">';
    html += '<a href="' + item.url + '" class="ccd-item__title">' + escapeHtml(item.product_title) + '</a>';
 
    // Variante
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<div class="ccd-item__variant">' + escapeHtml(item.variant_title) + '</div>';
    }
 
    // Propiedades (para suscripciones, etc.)
    if (item.properties) {
      var propsHtml = '';
      for (var key in item.properties) {
        if (item.properties.hasOwnProperty(key) && item.properties[key] && key.charAt(0) !== '_') {
          propsHtml += '<div>' + escapeHtml(key) + ': ' + escapeHtml(item.properties[key]) + '</div>';
        }
      }
      if (propsHtml) {
        html += '<div class="ccd-item__properties">' + propsHtml + '</div>';
      }
    }
 
    // Selling Plan (para suscripciones)
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      html += '<div class="ccd-item__properties">';
      html += escapeHtml(item.selling_plan_allocation.selling_plan.name);
      html += '</div>';
    }
 
    // Precio y cantidad
    html += '<div class="ccd-item__price-row">';
 
    // Cantidad
    html += '<div class="ccd-item__quantity">';
    html += '<button type="button" class="ccd-item__qty-btn js-qty-minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">-</button>';
    html += '<span class="ccd-item__qty-value">' + item.quantity + '</span>';
    html += '<button type="button" class="ccd-item__qty-btn js-qty-plus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>';
    html += '</div>';
 
    // Precio
    html += '<div class="ccd-item__price">';
 
    // Mostrar precio original si hay descuento
    if (item.original_line_price !== item.final_line_price) {
      html += '<span class="ccd-item__price--original">' + formatMoney(item.original_line_price) + '</span>';
    }
 
    html += formatMoney(item.final_line_price);
    html += '</div>';
 
    html += '</div>';
 
    // Boton eliminar
    html += '<button type="button" class="ccd-item__remove js-remove-item" data-key="' + item.key + '">Remove</button>';
 
    // Descuentos del item
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
      item.line_level_discount_allocations.forEach(function(discount) {
        html += '<div class="ccd-footer__discount">';
        html += escapeHtml(discount.discount_application.title) + ' (-' + formatMoney(discount.amount) + ')';
        html += '</div>';
      });
    }
 
    html += '</div>'; // details
    html += '</div>'; // cart-item
 
    return html;
  }
 
  /**
   * Apply Wholesale Gorilla pricing to the cart drawer.
   * WSG modifies prices via DOM on product/collection pages but the cart API
   * always returns retail prices. This fetches WSG's wholesale cart proxy
   * and updates the drawer with the correct wholesale prices.
   */
  function applyWholesalePricing(cart) {
    if (typeof window.isWsgCustomer === 'undefined' || !window.isWsgCustomer) {
      return;
    }
    if (!cart || cart.item_count === 0) {
      return;
    }

    // Hide retail prices immediately to prevent flash of wrong prices
    var allPriceEls = elements.container.querySelectorAll('.ccd-item__price');
    var footerValue = elements.container.querySelector('.ccd-footer__value');
    allPriceEls.forEach(function(el) {
      el.style.opacity = '0.3';
    });
    if (footerValue) {
      footerValue.style.opacity = '0.3';
    }

    var totalPages = Math.ceil(cart.items.length / 20) || 1;

    // Build one proxy URL per page so ALL line items get wholesale prices
    // (WSG paginates the proxy cart at 20 items per page)
    var pageUrls = [];
    for (var p = 1; p <= totalPages; p++) {
      var proxyUrl = '/a/wsg/proxy/cart?pages=' + totalPages + '&page=' + p;

      // Use market-aware URL if available
      if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root && window.Shopify.routes.root !== '/') {
        proxyUrl = window.Shopify.routes.root + proxyUrl.replace(/^\//, '');
      }

      pageUrls.push(proxyUrl);
    }

    Promise.all(pageUrls.map(function(url) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('WSG proxy returned ' + response.status);
          return response.text();
        });
    }))
      .then(function(htmlPages) {
        var parser = new DOMParser();
        var docs = htmlPages.map(function(html) {
          return parser.parseFromString(html, 'text/html');
        });

        // Debug: log the WSG HTML structure to help diagnose selector issues
        console.log('[Custom Cart Drawer] WSG proxy HTML received (' + docs.length + ' page(s)), parsing prices...');

        // WSG cart HTML contains rows with variant IDs and wholesale prices.
        // Try multiple selector strategies to extract pricing data,
        // merging results across all fetched pages.
        var priceMap = {};
        var unitPriceMap = {};

        // Strategy 1: Items with data-variant-id or data-id and price elements
        docs.forEach(function(doc) {
          var wsgRows = doc.querySelectorAll('[data-variant-id], [data-id], tr[data-item], .wsg-cart-item, .wsg-item');
          wsgRows.forEach(function(row) {
            var vid = row.getAttribute('data-variant-id') || row.getAttribute('data-id');
            var linePrice = row.querySelector('.wsg-line-price, [data-line-price]');
            var itemPrice = row.querySelector('.wsg-item-price, [data-item-price]');
            if (vid && linePrice) {
              priceMap[String(vid)] = linePrice.textContent.trim();
            }
            if (vid && itemPrice) {
              unitPriceMap[String(vid)] = itemPrice.textContent.trim();
            }
          });
        });

        // Strategy 2: If no variant-keyed data found, try positional mapping
        // (price elements collected across all pages, in page order)
        if (Object.keys(priceMap).length === 0) {
          var prices = [];
          docs.forEach(function(doc) {
            var wsgLinePrices = doc.querySelectorAll('.wsg-line-price');
            var wsgItemPrices = doc.querySelectorAll('.wsg-item-price');
            var pagePrices = wsgLinePrices.length > 0 ? wsgLinePrices : wsgItemPrices;
            pagePrices.forEach(function(el) {
              prices.push(el);
            });
          });

          if (prices.length > 0 && prices.length === cart.items.length) {
            cart.items.forEach(function(item, index) {
              if (prices[index]) {
                priceMap[String(item.variant_id)] = prices[index].textContent.trim();
              }
            });
          }
        }

        // Strategy 3: Try table rows with price cells (common WSG pattern)
        // rowIndex is shared across pages so positional mapping stays aligned
        if (Object.keys(priceMap).length === 0) {
          var rowIndex = 0;
          docs.forEach(function(doc) {
            var tableRows = doc.querySelectorAll('table tr, .wsg-table tr');
            tableRows.forEach(function(row) {
              // Skip header rows
              if (row.querySelector('th')) return;
              // Skip subtotal/total summary rows so they never map onto a line item
              var rowClass = row.className || '';
              var rowText = row.textContent || '';
              if (/subtotal|total/i.test(rowClass) || /\bsub\s*-?\s*total\b|\btotal\b/i.test(rowText)) return;
              // Never map beyond the last cart item
              if (rowIndex >= cart.items.length) return;
              var priceCells = row.querySelectorAll('td');
              if (priceCells.length > 0) {
                // Look for a cell containing a price pattern ($X.XX)
                priceCells.forEach(function(cell) {
                  var text = cell.textContent.trim();
                  if (/^\$[\d,.]+$/.test(text) || /^[\d,.]+$/.test(text)) {
                    // This might be a price cell - check class for line vs unit
                    var cellClass = cell.className || '';
                    if (cellClass.indexOf('line') !== -1 || cellClass.indexOf('total') !== -1) {
                      priceMap[String(cart.items[rowIndex].variant_id)] = text;
                    }
                  }
                });
                rowIndex++;
              }
            });
          });
        }

        // Apply wholesale prices to the drawer
        var applied = 0;
        if (Object.keys(priceMap).length > 0) {
          cart.items.forEach(function(item) {
            var vid = String(item.variant_id);
            if (priceMap[vid]) {
              var drawerItem = elements.container.querySelector('.ccd-item[data-variant-id="' + vid + '"]');
              if (drawerItem) {
                var priceEl = drawerItem.querySelector('.ccd-item__price');
                if (priceEl) {
                  priceEl.innerHTML = priceMap[vid];
                  priceEl.style.opacity = '1';
                  applied++;
                }
              }
            }
          });
        }

        if (applied > 0) {
          console.log('[Custom Cart Drawer] Wholesale prices applied for ' + applied + ' items');
        } else {
          console.warn('[Custom Cart Drawer] No wholesale prices could be extracted from WSG proxy. Showing retail prices.');
          // Restore retail price visibility
          allPriceEls.forEach(function(el) {
            el.style.opacity = '1';
          });
        }

        // Update subtotal with WSG wholesale subtotal (take the last page that has one)
        var wsgSubtotal = null;
        docs.forEach(function(doc) {
          var subtotalEl = doc.querySelector('.wsg-cart-subtotal, .wsg-subtotal, [data-cart-subtotal]');
          if (subtotalEl) {
            wsgSubtotal = subtotalEl;
          }
        });
        if (wsgSubtotal) {
          if (footerValue) {
            footerValue.textContent = wsgSubtotal.textContent.trim();
          }
        }

        // Restore footer value visibility
        if (footerValue) {
          footerValue.style.opacity = '1';
        }
      })
      .catch(function(error) {
        console.warn('[Custom Cart Drawer] Could not fetch wholesale prices:', error);
        // Restore retail price visibility on error
        allPriceEls.forEach(function(el) {
          el.style.opacity = '1';
        });
        if (footerValue) {
          footerValue.style.opacity = '1';
        }
      });
  }


  /**
   * Renderizar carrito vacio
   */
  function renderEmptyCart() {
    var html = '<div class="ccd-scrollable">';
    html += '<div class="ccd-empty">';
    html += '<p class="ccd-empty__text">Your cart is empty</p>';
    html += '<a href="/collections/all" class="ccd-empty__link">Continue shopping</a>';
    html += '</div>';
    html += '</div>';

    elements.container.innerHTML = html;

    // Ocultar barra de envio gratis con carrito vacio
    updateShippingBar(null);
  }
 
  /**
   * Actualizar cantidad de un item
   */
  function updateItemQuantity(key, quantity) {
    if (state.isLoading) return;
 
    setLoading(true);
 
    fetch(config.routes.cartChange, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw data;
        });
      }
      return response.json();
    })
    .then(function(cart) {
      state.cart = cart;
      renderCart(cart);
      updateCartBubble(cart);
      setLoading(false);
    })
    .catch(function(error) {
      console.error('[Custom Cart Drawer] Error al actualizar cantidad:', error);
      setLoading(false);
      // Mantener el estado anterior del carrito renderizado y mostrar el error
      showDrawerError(error);
    });
  }
 
  /**
   * Eliminar item del carrito
   */
  function removeItem(key) {
    updateItemQuantity(key, 0);
  }
 
  /**
   * Abrir drawer
   */
  function openDrawer() {
    if (state.isOpen) return;
 
    state.isOpen = true;
    elements.drawer.classList.add(config.classes.drawerOpen);
 
    if (elements.overlay) {
      elements.overlay.classList.add(config.classes.overlayVisible);
    }
 
    document.body.classList.add(config.classes.bodyOpen);
    document.body.style.overflow = 'hidden';
 
    console.log('[Custom Cart Drawer] Drawer abierto');
  }
 
  /**
   * Cerrar drawer
   */
  function closeDrawer() {
    if (!state.isOpen) return;
 
    state.isOpen = false;
    elements.drawer.classList.remove(config.classes.drawerOpen);
 
    if (elements.overlay) {
      elements.overlay.classList.remove(config.classes.overlayVisible);
    }
 
    document.body.classList.remove(config.classes.bodyOpen);
    document.body.style.overflow = '';
 
    console.log('[Custom Cart Drawer] Drawer cerrado');
  }
 
  /**
   * Establecer estado de carga
   */
  function setLoading(loading) {
    state.isLoading = loading;
 
    if (loading) {
      elements.drawer.classList.add(config.classes.loading);
    } else {
      elements.drawer.classList.remove(config.classes.loading);
    }
  }
 
  /**
   * Actualizar burbuja del carrito en el header
   */
  function updateCartBubble(cart) {
    var count = cart ? cart.item_count : 0;
 
    // Actualizar todos los elementos de contador del carrito
    document.querySelectorAll('.cart-link__bubble, .cart-count, .cart-link__count, [data-cart-count]').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.classList.add('cart-link__bubble--visible');
        el.style.display = '';
      } else {
        el.textContent = '';
        el.classList.remove('cart-link__bubble--visible');
      }
    });
  }
 
  /**
   * Disparar eventos para compatibilidad con otros scripts
   */
  function dispatchCartEvents(item) {
    // Evento jQuery si esta disponible
    if (typeof jQuery !== 'undefined') {
      jQuery('body').trigger('added.ajaxProduct');
      jQuery('body').trigger('ajaxCart.afterCartLoad');
    }
 
    // Eventos nativos
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: state.cart, item: item }
    }));
 
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: item }
    }));
  }
 
  /**
   * Mostrar error
   */
  function showError(form, error) {
    var message = 'Error adding to cart';
 
    if (error && error.description) {
      message = error.description;
    } else if (error && error.message) {
      message = error.message;
    }
 
    // Remover errores previos
    var existingError = form.querySelector('.custom-cart-error');
    if (existingError) {
      existingError.remove();
    }
 
    // Agregar nuevo error
    var errorDiv = document.createElement('div');
    errorDiv.className = 'custom-cart-error errors text-center';
    errorDiv.style.cssText = 'color: #c00; padding: 10px; margin-bottom: 10px;';
    errorDiv.textContent = message;
    form.insertBefore(errorDiv, form.firstChild);
 
    // Remover error despues de 5 segundos
    setTimeout(function() {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }
 
  /**
   * Mostrar error dentro del drawer (adaptacion de showError para el
   * contexto del drawer, p.ej. fallos de /cart/change.js)
   */
  function showDrawerError(error) {
    var message = 'Could not update cart';

    if (error && error.description) {
      message = error.description;
    } else if (error && error.message) {
      message = error.message;
    }

    // Remover errores previos
    var existingError = elements.container.querySelector('.ccd-error');
    if (existingError) {
      existingError.remove();
    }

    // Agregar nuevo error al tope del contenedor del drawer
    var errorDiv = document.createElement('div');
    errorDiv.className = 'ccd-error';
    errorDiv.style.cssText = 'color: #ff6b6b; padding: 10px 25px; font-size: 13px; text-align: center;';
    errorDiv.textContent = message;
    elements.container.insertBefore(errorDiv, elements.container.firstChild);

    // Remover error despues de 5 segundos
    setTimeout(function() {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }

  /**
   * Formatear dinero
   */
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
 
    var value = (cents / 100).toFixed(2);
    var format = config.moneyFormat;
 
    return format
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }
 
  /**
   * Obtener URL de imagen con tamano especifico
   */
  function getSizedImageUrl(url, size) {
    if (!url) return '';
 
    // Remover parametros de query existentes
    var baseUrl = url.split('?')[0];
 
    // Insertar el tamano antes de la extension
    var match = baseUrl.match(/\.(jpg|jpeg|gif|png|webp)(\?.*)?$/i);
    if (match) {
      return baseUrl.replace(match[0], '_' + size + match[0]);
    }
 
    return url;
  }
 
  /**
   * Escapar HTML
   */
  function escapeHtml(text) {
    if (!text) return '';
 
    var div = document.createElement('div');
    div.textContent = text;
    // innerHTML no escapa comillas dobles, pero el resultado se usa en
    // contexto de atributo (alt="..."), asi que hay que escaparlas tambien
    return div.innerHTML.replace(/"/g, '&quot;');
  }
 
  // Inicializar cuando el DOM este listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Exponer API publica
  window.CustomCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: fetchCart,
    getCart: function() { return state.cart; }
  };
})();

// Función para ocultar/mostrar el chat de Shopify
function toggleShopifyChat(hide) {
  const shopifyChat = document.getElementById('shopify-chat');
  if (shopifyChat) {
    shopifyChat.style.display = hide ? 'none' : '';
    shopifyChat.style.visibility = hide ? 'hidden' : '';
  }
}

// Cuando abres el drawer:
function openCartDrawer() {
  document.getElementById('CustomCartDrawer').classList.add('is-open');
  document.getElementById('CustomCartOverlay').classList.add('is-visible');
  toggleShopifyChat(true); // Ocultar chat
}

// Cuando cierras el drawer:
function closeCartDrawer() {
  document.getElementById('CustomCartDrawer').classList.remove('is-open');
  document.getElementById('CustomCartOverlay').classList.remove('is-visible');
  toggleShopifyChat(false); // Mostrar chat
}